
import customAxios from "config";
import { renterError } from "utils/errorMessage";

export const SaveSquareCard = async (
  renterId: string,
  cardNonce: string
): Promise<any> => {
  try {
    const response = await customAxios.post("/api/square/cards/", {
      renter_id: renterId,
      card_nonce: cardNonce,
    });
    return response.data;
  } catch (error) {
    return { error: renterError(error, "payment") };
  }
};

// Helper for headers if needed (optional, since customAxios can handle auth)
const getAuthHeaders = () => ({
  "Content-Type": "application/json",
});

// Get Square Details
export const getSquareDetails = async (): Promise<any> => {
  try {
    const response = await customAxios.get("/api/square/details/", {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    return { error: renterError(error, "payment") };
  }
};

// Charge Square Card
export const chargeSquareCard = async (
  bookingId: string,
  paymentMethodId: string,
  requestId?: string
): Promise<any> => {
  try {
    // 1NOW-10711: one id per click. The backend claims it before any money
    // moves and derives Square's idempotency key from it, so a replay of this
    // click returns the original outcome instead of charging the card again.
    let body: any = { booking_id: bookingId, card_id: paymentMethodId };
    if (requestId) body.request_id = requestId;
    const response = await customAxios.post("/api/square/charge-card/", body, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    return { error: renterError(error, "payment") };
  }
};
